import React from "react";
var __jsx = React.createElement;
import { SegmentedControl } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { MODE_TOGGLE_STYLES } from "./date-field-styles";
/** By day / By month segmented toggle shown for month-range-enabled ranges. */
export function ModeToggle(_ref) {
  var mode = _ref.mode,
    _onChange = _ref.onChange,
    testId = _ref.testId;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(SegmentedControl, {
    size: "xs",
    fullWidth: true,
    className: "mb-3",
    value: mode,
    onChange: function onChange(value) {
      return _onChange(value);
    },
    data: [{
      value: "day",
      label: t("by_day", {
        defaultValue: "By day"
      })
    }, {
      value: "month",
      label: t("by_month", {
        defaultValue: "By month"
      })
    }],
    styles: MODE_TOGGLE_STYLES,
    "data-testid": "".concat(testId, "-mode")
  });
}